import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M8.25 7.505V6.113c0-1.135.845-2.098 1.976-2.192q.56-.047 1.124-.08m4.4 14.164H18a2.25 2.25 0 0 0 2.25-2.25V6.113c0-1.135-.845-2.098-1.976-2.192a48 48 0 0 0-1.123-.08M15.75 18.755V16.88a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 9.75 12.38v-1.5a3.375 3.375 0 0 0-3.375-3.375H5.25m11.9-3.664A2.25 2.25 0 0 0 15 2.255h-1.5a2.25 2.25 0 0 0-2.15 1.586m5.8 0q.099.316.1.664v.75h-6v-.75q.001-.348.1-.664m-4.6 3.664H4.875c-.621 0-1.125.503-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125v-4.125a9 9 0 0 0-9-9"
    }, null, -1)
  ])))
}
export default { render: render }